const fromRole = (role) => {
  let id = 0;
  switch (role) {
    case 'Administrador':
      id = 1;
      break;
    case 'Profesor':
      id = 2;
      break;
    case 'Estudiante':
      id = 3;
      break;
    case 'Administrador del Sistema':
      id = 4;
      break;
  }
  return {role, id};
}

export default {
  ADMIN: 'Administrador',
  TEACHER: 'Profesor',
  STUDENT: 'Estudiante',
  ADMIN_SIS: 'Administrador del Sistema',
  fromRole
}



// WEBPACK FOOTER //
// ./src/utils/role.js